/**
 * The clinician dashboard URL for a longitudinal share.
 *
 * The share token and the CEK both travel in the URL fragment
 * (`/provider/longitudinal/shared#t=<token>&k=<cek>`). A browser never sends the
 * fragment to a server, so neither value reaches the dashboard's request URL,
 * its load balancer log or Cloud Run's request trace.
 */
export function longitudinalDashboardUrl(dashboardBase: string, token: string, hash: string): string {
  const rest = hash.startsWith("#") ? hash.slice(1) : hash;
  const fragment = `t=${encodeURIComponent(token)}${rest ? `&${rest}` : ""}`;
  return `${dashboardBase.replace(/\/$/, "")}/provider/longitudinal/shared#${fragment}`;
}
